module.exports = __webpack_public_path__ + "static/media/2.96080590.webp";